/**
 * Return hash of current querystring values
 * @param {RegExp} [filter] Optionally filter name of returned values
 * @param {(key: string) => string} [rekey] Optional function to rename keys
 * @param {string} [url] URL to use if not the current browser location
 * @returns {Object<string, string | undefined>|null}
 */
export function urlParams(filter: RegExp | undefined, rekey = (key: string) => key, url = '') {
    /** @type {Location|HTMLAnchorElement} */
    let location;

    if (url) {
        location = document.createElement('a');
        location.href = url;
    } else {
        location = window.location;
    }

    if (!location.search) return null;
    if (!rekey || typeof rekey !== 'function') rekey = (key) => key;

    const pairs = location.search
        .split('?')[1]
        .split('&')
        .map((pair) => pair.split('='))
        .filter((pair) => pair.length === 2)
        .filter((pair) => !filter || filter.test(pair[0]));

    return pairs.length > 0
        ? pairs.reduce((hash, pair) => {
              const value = decodeURIComponent(pair[1].replace(/\+/g, ' '));
              if (pair[0].slice(-2) === '[]') {
                  // we have an array param
                  if (hash[rekey(pair[0])]) {
                      hash[rekey(pair[0])].push(value);
                  } else {
                      hash[rekey(pair[0])] = [value];
                  }
              } else {
                  // normal value
                  hash[rekey(pair[0])] = value;
              }
              return hash;
          }, {} as any)
        : null;
}

export const getUtms = () => {
    const sessionKeys = Object.keys(sessionStorage);
    for (const key of sessionKeys) {
        if (/^(utm|googleclickid|microsoftclickid)/i.test(key)) {
            const utm = sessionStorage.getItem(key);
            if (utm) {
                const value = JSON.parse(utm);
                mapSalesforceUtms(key, value);
            }
        }
    }

    return salesforceUTM;
};

const salesforceUTM = {
    utmTerm: '',
    utmSource: '',
    utmMedium: '',
    utmContent: '',
    utmCampaign: '',
    googleClickID: '',
    microsoftClickID: '',
};

const mapSalesforceUtms = (key: string, value: string) => {
    //The index of the urm string after utm_
    const index = 4;
    if (key.toLowerCase().startsWith('term', index)) {
        salesforceUTM.utmTerm = value;
    } else if (key.toLowerCase().startsWith('source', index)) {
        salesforceUTM.utmSource = value;
    } else if (key.toLowerCase().startsWith('medium', index)) {
        salesforceUTM.utmMedium = value;
    } else if (key.toLowerCase().startsWith('content', index)) {
        salesforceUTM.utmContent = value;
    } else if (key.toLowerCase().startsWith('campaign', index)) {
        salesforceUTM.utmCampaign = value;
    } else if (key.toLowerCase() == 'googleclickid') {
        salesforceUTM.googleClickID = value;
    } else if (key.toLowerCase() == 'microsoftclickid') {
        salesforceUTM.microsoftClickID = value;
    }
};
